(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo_slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('section.photo-slider-45');
  sections.forEach(section => {
    const track = section.querySelector('.photo-slider-track');
    const slides = Array.from(section.querySelectorAll('.photo-slide'));
    if (!slides.length) return;

    const showArrows = section.dataset.arrows === 'true';
    const showDots = section.dataset.dots === 'true';
    const loop = section.dataset.loop === 'true';
    const autoplay = section.dataset.autoplay === 'true';
    const pauseOnHover = section.dataset.pause === 'true';
    const interval = parseInt(section.dataset.interval || '5000', 10);
    let index = 0;
    let timer = null;

    function goTo(i) {
      index = loop ? (i + slides.length) % slides.length : Math.max(0, Math.min(i, slides.length - 1));
      track.style.transform = 'translateX(' + (-100 * index) + '%)';
      updateDots();
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    let dotsWrap = null;
    if (showDots) {
      dotsWrap = section.querySelector('.ps45-dots');
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        slides.forEach((_, i) => {
          const b = document.createElement('button');
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          b.addEventListener('click', () => goTo(i));
          dotsWrap.appendChild(b);
        });
      }
    }
    function updateDots() {
      if (!dotsWrap) return;
      Array.from(dotsWrap.children).forEach((b, i) => {
        b.toggleAttribute('aria-current', i === index);
      });
    }

    if (showArrows) {
      const prevBtn = section.querySelector('.ps45-prev');
      const nextBtn = section.querySelector('.ps45-next');
      if (prevBtn) prevBtn.addEventListener('click', prev);
      if (nextBtn) nextBtn.addEventListener('click', next);
    }

    function start() { if (autoplay) { stop(); timer = setInterval(next, interval); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (pauseOnHover) {
      section.addEventListener('mouseenter', stop);
      section.addEventListener('mouseleave', start);
    }

    goTo(0);
    start();

    window.addEventListener('resize', () => {
      track.style.transition = 'none';
      requestAnimationFrame(() => {
        track.style.transform = 'translateX(' + (-100 * index) + '%)';
        requestAnimationFrame(() => track.style.transition = 'transform 500ms ease');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
